// extracted by mini-css-extract-plugin
module.exports = {"notificationToast":"notification-toast_notificationToast__2qWn7","icon":"notification-toast_icon__39-KT","text":"notification-toast_text__3yQ83"};